import React from 'react';

import axios from 'axios';
import ClockIcon from 'icons/clock.svg';
import { useTranslation } from 'react-i18next';

import useForm from 'components/hooks/useForm';
import useRequestError from 'components/hooks/useRequestError';

import ActionButton from 'components/buttons/ActionButton';
import { withBranding } from 'components/messages/DownloadContainer';
import PasswordField from 'components/messages/PasswordField';

export default function MessageAccessContainer({
  accessibilityStatus,
  companyBranding,
  messageInfo,
}) {
  const [requestError, , , , handleRequestError] = useRequestError();

  const [passwordInput, , handlePasswordInputChange] = useForm({
    password: '',
  });

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'messages.MessageAccessContainer',
  });

  const { t: i18nTCommon } = useTranslation('common');

  const { buttonBgColour, buttonTextColour } = companyBranding.data.attributes;

  const BrandedButton = withBranding(ActionButton, {
    backgroundColor: buttonBgColour,
    color: buttonTextColour,
  });

  const submitPassword = () => {
    axios
      .post(`/messages/${messageInfo.hashid}/message_access`, passwordInput)
      .then((response) => {
        window.location.assign(
          `/messages/${messageInfo.hashid}?token=${response.data.data.meta.token}`,
        );
      })
      .catch(handleRequestError);
  };

  const handleInputKeyDown = (event) => {
    if (event.key === 'Enter') {
      submitPassword();
    }
  };

  const renderComponent = () => {
    switch (accessibilityStatus) {
      case 'disabled':
      case 'expired':
        return <DownloadUnavailableComponent status={accessibilityStatus} />;
      case 'protected':
        return (
          <PasswordField
            errorMessage={i18nT('passwordField.error')}
            instructionMessage={i18nT('passwordField.instructions')}
            onInputKeyDown={handleInputKeyDown}
            onPasswordInputChange={handlePasswordInputChange}
            passwordInput={passwordInput}
            validationError={requestError.validationErrors.password}
          >
            <BrandedButton
              buttonText={i18nTCommon('shared.continue')}
              onClick={submitPassword}
            />
          </PasswordField>
        );
    }
  };

  return (
    <div className='download-container tw-bg-white'>
      <div className='download-container__title tw-font-medium'>
        {messageInfo.companyName}
      </div>
      <div className='download-container__name tw-text-xl tw-font-semibold tw-tracking-tight tw-text-grey-900'>
        {messageInfo.projectName}
      </div>
      {renderComponent()}
    </div>
  );
}

function DownloadUnavailableComponent({ status }) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'messages.MessageAccessContainer.downloadUnavailable',
  });

  return (
    <div className='download-container__sub-text tw-mt-5 tw-text-red-600'>
      {status === 'expired' && (
        <ClockIcon
          className='download-container__svg tw-mb-0.5 tw-mr-0.5 [&_path]:tw-fill-red-600'
          height={18}
          width={18}
        />
      )}
      {i18nT(status)}
    </div>
  );
}
